module.exports = __webpack_public_path__ + "static/Woman-using-MacBook-13inch-1874242ec20a455c28c0a04fb10af546.png";